import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { AudioManager } from "../../AudioManager";
import { GameVars } from "../../GameVars";

export class PauseLayer extends Phaser.Group {
    
    constructor(game: Phaser.Game) {

        super(game, null, "pause-layer");

        const darkLayer = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        darkLayer.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, GameConstants.GAME_HEIGHT / GameConstants.BITMAP_SIZE);
        darkLayer.inputEnabled = true;
        darkLayer.events.onInputDown.add(this.backToGame, this);
        darkLayer.alpha = .65;
        this.add(darkLayer);

        const scaledContainer = new Phaser.Group(this.game);
        scaledContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledContainer.scale.x = GameVars.scaleX;
        this.add(scaledContainer);

        const pauseMenuBackground = new Phaser.Image(this.game, 0, 120, "texture_atlas_1", "pause.png");
        pauseMenuBackground.anchor.set(.5, 0);
        scaledContainer.add(pauseMenuBackground);

        const soundButton = new Phaser.Button(this.game, 0, 195, "texture_atlas_1", this.onSoundButtonDown, this);
        soundButton.scale.x = GameVars.scaleX;
        soundButton.anchor.set(.5);
        scaledContainer.add(soundButton);

        if (GameVars.gameData.muted) {
            soundButton.setFrames("btn_sound_off_on.png", "btn_sound_off_off.png", "btn_sound_off_on.png", "btn_sound_off_off.png");
        } else {
            soundButton.setFrames("btn_sound_on_on.png", "btn_sound_on_off.png", "btn_sound_on_on.png", "btn_sound_on_off.png");
        }

        const restartButton = new Phaser.Button(this.game, 0, 255, "texture_atlas_1", this.oRestartButtonDown, this);
        restartButton.setFrames("btn_restart_on.png", "btn_restart_off.png", "btn_restart_on.png");
        restartButton.scale.x = GameVars.scaleX;
        restartButton.anchor.set(.5);
        scaledContainer.add(restartButton);

        const homeButton = new Phaser.Button(this.game, 0, 310, "texture_atlas_1", this.onHomeButtonDown, this);
        homeButton.setFrames("btn_home_on.png", "btn_home_off.png", "btn_home_on.png");
        homeButton.scale.x = GameVars.scaleX;
        homeButton.anchor.set(.5);
        scaledContainer.add(homeButton);

        if (/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {

            pauseMenuBackground.y = 70;
            pauseMenuBackground.scale.set(1.5);

            const dpadButton = new Phaser.Button(this.game, 0, 250, "texture_atlas_1", this.onDpadButtonDown, this);
            dpadButton.setFrames("btn_switch_d_pad_on.png", "btn_switch_d_pad_off.png", "btn_switch_d_pad_on.png", "btn_switch_d_pad_off.png");
            dpadButton.scale.x = GameVars.scaleX;
            dpadButton.anchor.set(.5);
            scaledContainer.add(dpadButton);

            soundButton.y = 165;
            restartButton.y = 330;
            homeButton.y = 385;
        }
    }

    public backToGame(): void {

        GameManager.hidePauseLayer();
    }

    private onDpadButtonDown(): void {

        GameManager.switchdPad();

        AudioManager.playSound("click");
    }

    private onSoundButtonDown(button: Phaser.Button): void {

        AudioManager.playSound("click");

        GameManager.switchSound();

        if (GameVars.gameData.muted) {
            button.setFrames("btn_sound_off_on.png", "btn_sound_off_off.png", "btn_sound_off_on.png", "btn_sound_off_off.png");
        } else {
            button.setFrames("btn_sound_on_on.png", "btn_sound_on_off.png", "btn_sound_on_on.png", "btn_sound_on_off.png");
        }
    }

    private oRestartButtonDown(): void {

        GameManager.reset();
    }

    private onHomeButtonDown(): void {

        GameManager.enterSplashScene();

        AudioManager.playSound("click");
    }
}
